import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { fetchJobRoles, deleteJobRoles } from '../services/career';
import CareerJobEdit from './CareerJobEdit';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CareerJobUpdate = () => {
  const [jobRoles, setJobRoles] = useState([]);
  const [selectedJobRole, setSelectedJobRole] = useState();
  const navigate = useNavigate();

  const notifySuccess = (alertMessage) => {
    toast.success(alertMessage);
  };

  const notifyDanger = (alertMessage) => {
    toast.error(alertMessage);
  };

  const handleAddNew = () => {
    setSelectedJobRole({
      _id: '',
      roleName: '',
      categories: [],
      location: '',
      package: '',
      description: '',
    });
  };

  useEffect(() => {
    getJobRoles();
  }, []);

  const handleLocalUpdate = (updatedLocalJob) => {
    const newJob = jobRoles.filter((role) => role._id !== updatedLocalJob._id);
    newJob.push(updatedLocalJob);
    setJobRoles(newJob);
  };

  const getJobRoles = async () => {
    try {
      const response = await fetchJobRoles();
      if (response.message) {
        setJobRoles(response.jobRoles || []);
      } else {
        toast.error(response.error || 'Failed to fetch job roles');
      }
    } catch (error) {
      toast.error(
        error.message || 'An error occurred while fetching job roles'
      );
    }
  };

  const handleDeleteJobRole = async (id) => {
    try {
      const response = await deleteJobRoles(id);
      if (response.message) {
        toast.success(response.message || 'successfully deleted');
        const updatedJobRoles = jobRoles.filter((role) => role._id !== id);
        setJobRoles(updatedJobRoles);
      } else {
        toast.error(response.error || 'something went wrong');
      }
    } catch (error) {
      toast.error(error.message || 'Something went wrong');
    }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <ToastContainer />

      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-md bg-gray-200 text-gray-700 text-sm font-medium hover:bg-gray-300 transition w-fit mb-4"
      >
        <ArrowLeft size={16} />
        Back
      </button>

      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-semibold text-gray-800">Job Roles</h1>
        <button
          onClick={handleAddNew}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md transition-all text-sm"
        >
          Add New Job Role
        </button>
      </div>

      {selectedJobRole ? (
        <CareerJobEdit
          jobRole={selectedJobRole}
          onClose={() => setSelectedJobRole(null)}
          handleLocalUpdate={handleLocalUpdate}
          notifySuccess={notifySuccess}
          notifyDanger={notifyDanger}
        />
      ) : jobRoles.length > 0 ? (
        <div className="w-full overflow-hidden border border-gray-200 rounded-lg shadow-sm bg-white">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full text-left text-sm whitespace-nowrap">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 font-semibold text-gray-600">Role Name</th>
                  <th className="px-4 py-3 font-semibold text-gray-600">Categories</th>
                  <th className="px-4 py-3 font-semibold text-gray-600">Location</th>
                  <th className="px-4 py-3 font-semibold text-gray-600">Package</th>
                  <th className="px-4 py-3 font-semibold text-gray-600">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {jobRoles.map((jobRole) => (
                  <tr
                    key={jobRole._id}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-4 py-3 text-gray-900 font-medium">{jobRole.roleName}</td>
                    <td className="px-4 py-3 text-gray-900">
                      {Array.isArray(jobRole.categories)
                        ? jobRole.categories.join(', ')
                        : jobRole.categories || '-'}
                    </td>
                    <td className="px-4 py-3 text-gray-900">{jobRole.location || '-'}</td>
                    <td className="px-4 py-3 text-gray-900">{jobRole.package || '-'}</td>
                    <td className="px-4 py-3">
                      <div className="flex gap-2">
                        <button
                          onClick={() => setSelectedJobRole(jobRole)}
                          className="bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded text-xs font-medium transition"
                        >
                          View/Edit
                        </button>
                        <button
                          onClick={() => handleDeleteJobRole(jobRole._id)}
                          className="bg-red-500 hover:bg-red-600 text-white py-1 px-3 rounded text-xs font-medium transition"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="text-center text-gray-500 mt-10">
          <h1 className="text-lg">No job roles available</h1>
        </div>
      )}
    </div>
  );
};

export default CareerJobUpdate;
